export const types = {
  SET_REGISTRATION_USERNAME: 'SET_REGISTRATION_USERNAME',
  SET_REGISTRATION_EMAIL: 'SET_REGISTRATION_EMAIL',
  SET_REGISTRATION_AGREEMENTS: 'SET_REGISTRATION_AGREEMENTS',
  SET_FORM_FROM_API: 'SET_FORM_FROM_API',
};
